import { UserEmailEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const EncryptionOwnerResource = authResource({
    path: '/encryptions/owners/:id',
    searchParams: {},
    schema: UserEmailEntity
})
    .extend('getList', {
    schema: paginatedSchema(UserEmailEntity)
})
    .extend((BaseResource) => ({
    getBulkList: BaseResource.getList.extend({
        method: 'POST',
        body: {},
        schema: paginatedSchema(UserEmailEntity),
        process: (response) => ({
            count: response.length,
            items: [...response]
        }),
        sideEffect: false
    })
}));
